module.exports = __webpack_public_path__ + "img/gereg2.dc107f1b.jpg";